import React from 'react';

export const InputTextAreaComponent = (/** @type {{value: string; onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void; }} */ { value, onChange }) => {
    return (
        <div className={'InputComponent InputContainer'}>
            <textarea
                rows={8}
                value={value}
                onChange={(e) => onChange(e)}
            />
        </div>
    );
};
